import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper'; 
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, SelectBox, Popup } from 'devextreme-react';
import { vendorListService } from '../services/vendor-list-service';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import { confirm } from 'devextreme/ui/dialog';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { toast } from 'react-toastify';

const SupplierList = () => {

    let LocationCode: any;
    let SupplierCode: any;
    let CategoryCode: any;
    let ProductCode: any;

    const dataGridRef = useRef<DataGrid>(null);
    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["locationCode", "productCode", "vendorCode"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])

    const onGetOrderData = useCallback(async () => {
        const x = await vendorListService.getSupplierList();
        return x;
    }, []);

    const onQuery = useCallback(async () => {
        dataGridRef.current?.instance.refresh();
    }, []);

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };


    const onSave = async () => {
        if (dataGridRef.current?.instance.hasEditData()) {
            let result = confirm(t("syncflow:msg_save_confirm"), t("syncflow:ti_confirm"));
            result.then((dialogResult) => {
                if (dialogResult) {
                    dataGridRef.current?.instance.saveEditData();
                }
            });
        }
    }

    const onSaving = (e: DataGridTypes.SavingEvent) => {
        e.cancel = true;
        if (e.changes.length > 0) {
            vendorListService.updateProductPortfolio(e.changes).then((response) => {
                dataGridRef.current?.instance.refresh().then(x => dataGridRef.current?.instance.cancelEditData());
                toast.success(t("syncflow:msg_saved"));
            });
        }
    }


    const onCellPrepared = async (e: any) => {
        if (e.hasOwnProperty("data")) {
            if (e.column.dataField === 'paymentTerm' || e.column.dataField === 'adress'
                || e.column.dataField === 'country' || e.column.dataField === 'city'
                || e.column.dataField === 'district' || e.column.dataField === 'phone'
                || e.column.dataField === 'email' || e.column.dataField === 'isActive') {
                e.cellElement.style.backgroundColor = '#E6F1FF';
            }
        }
    };

      function onEditorPreparing(e: any) {
            if (e.parentType === "dataRow" && e.dataField === "phone") {
                e.editorOptions.mask = "(000) 000-0000";
            }
        }

    return (
        <>
            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_list")}
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_save")}
                        type="default"
                        icon="save"
                        onClick={onSave}
                    />
                </div>
            </div>

            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    filterVisible={false} 
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    onEditorPreparing={onEditorPreparing}
                    onCellPrepared={onCellPrepared}
                    onSaving={onSaving}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: true,
                        updateMessageText: RemoveMessage('Resource'),
                    }}
                    columns={[
                        {
                            dataField: 'vendorCode',
                            caption: t('syncflow:lb_supplier_code'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible: false,
                        },
                        {
                            dataField: 'vendorName',
                            caption: t('syncflow:lb_supplier_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'paymentTerm',
                            caption: t('syncflow:lb_payment_term'),
                            allowFiltering: true,
                            allowEditing: true,
                            dataType: 'number',
                        },
                        {
                            dataField: 'adress',
                            caption: t('syncflow:lb_adress'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'country',
                            caption: t('syncflow:lb_country'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'city',
                            caption: t('syncflow:lb_city'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'district',
                            caption: t('syncflow:lb_district'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'phone',
                            caption: t('syncflow:lb_phone'),
                            allowFiltering: true,
                            allowEditing: true,
                        },
                        {
                            dataField: 'email',
                            caption: t('syncflow:lb_email'),
                            allowFiltering: true,
                            allowEditing: true,
                            emailRule: true,
                        },
                        {
                            dataField: 'isActive',
                            caption: t('syncflow:is_active'),
                            allowFiltering: true,
                            allowEditing: true,
                            dataType: 'boolean'
                        },
                        {
                            dataField: 'hasAccount',
                            caption: t('syncflow:lb_has_account'),
                            allowFiltering: true,
                            allowEditing: false,
                            dataType: 'boolean'
                        }
                    ]}
                />
            </React.Fragment>

        </>
    )
}
export default SupplierList